import { useState, useEffect } from 'react';
import { IonContent, IonPage, IonModal, IonToast } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { base64FromPath } from '@ionic/react-hooks/filesystem';
import {config} from '../Constants';
import CryptoJS from 'crypto-js';
import React from 'react';
import { Camera } from '@capacitor/camera';

import trailerId from "../imgs/test_trailer_1.jpg";
import { ApiService } from '../api/ApiService';
import { ChevronRight, CameraIcon, TrashIcon } from '../components/icons';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import TrailerPhotoIdFirstIn from '../components/walkthrough/individualPage/TrailerPhotoIdFirstIn';
import { useLogPageVisit } from '../utils/logPageVisit';
import { logUserAction } from '../utils/logUserAction';

const timages: any[] = [];

interface Photo {
    filepath: string;
    webviewPath?: string;
    data: any;
}

let hashArray: any = [];

const TrailerIdPhotos: React.FC<{moduleHistory: string}> = ({ moduleHistory }) => {
    useLogPageVisit('LP Trailer Plate Photos', 'User viewed the Trailer Plate Photos page');
    const history = useHistory();
    const { onSheet, onIonScroll } = useTransparentHeaderContrast();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(false);
    const [successPhoto, setSuccess] = useState(false);
    const [toast, setToast] = useState<string>("")
    const [images, setImages] = useState<Photo[]>([]);
    const [trailerReport, setTrailerReport] = useState<string>("");
    const [unitNumber, setUnitNumber] = useState("");
    const [openExample, setOpenExample] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        // get the unit # from userProfile
        var data = new FormData()
        data.append("payload", JSON.stringify({ cmds: [{cmd: "driverProfile", args: {ownerCode: localStorage.getItem('username')?.toUpperCase(), loginToken: localStorage.getItem('token')}}] }))
        const requestOptions = {
            method: 'POST',
            headers: {},
            body: data
        };

        console.log(requestOptions)
        //debug log ^^
        fetch(config.url.BASE_URL, requestOptions).then(response => response.json())
        .then(json =>
        {
            if (json.results[0].errcode === 'NOTLOGGEDIN')
                 {localStorage.removeItem('token')}
            else if (json.results[0].errmsg){
                console.error("Error: ", json.results[0].errmsg);
            }
                else {
                    setUnitNumber(json.results[0].unit)
                }
        })


        //getting the load #
    }, [])




    //tool functions
    async function removeHashes(removalArray: any) {
        removalArray.forEach(async (element: any) => {
          await ApiService.photoChecksumRevoke("tarpPhotos", {checksum: element}).then(it => {
            hashArray = hashArray.filter((hash: any) => hash !== element)
          })
        });
      }





    enum CameraResultType {
        Uri = 'uri',
        Base64 = 'base64',
        DataUrl = 'dataUrl'
    }

    const b64toBlob = (base64: any) => fetch(base64).then(res => res.blob())

    async function submitTrailerIdPhotos(){
        setLoading(true)
        try {
            var data = new FormData();
            data.append("payload", JSON.stringify({ cmds: [{cmd: "trailerIdUpload", args: {loginToken: localStorage.getItem('token'), unitId: unitNumber}}]}))
            for(let i = 0; i < images.length; i++){
                data.append(`photo`, new Blob([(await b64toBlob(images[i].data))],{type: 'application/octet-stream'}));
            }
            const requestOptions = {
                method: 'POST',
                body: data
              };
            const response = await fetch(config.url.BASE_URL, requestOptions);
            const json = await response.json();
            if (json.results[0].errmsg) {
                setShowErrorModal(true);
                removeHashes(hashArray);
                setLoading(false);
            } else {
                logUserAction('LP Trailer Upload', 'User submitted trailer plate photos');
                setLoading(false);
                setSuccess(true);
                setTrailerReport(JSON.stringify(json.results[0]));
            }
        } catch (err) {
            setLoading(false);
            setToast("Your photo could not be uploaded. Please check your connection and try again.");
            setShowToast(true);
        }
    }
    async function takePicture() {
        const image = await Camera.getPhoto({
          quality: 30,
          allowEditing: false,
          resultType: CameraResultType.Uri
        });
        const fileName = new Date().getTime() + '.jpeg';
        // await addDateTime(image.webPath!)
        const base64Data = await base64FromPath(image.webPath!);
        console.log("data");
        const newPhotos = [{
          filepath: fileName,
          webviewPath: image.webPath,
          data: base64Data
        }, ...images];
        setImages(newPhotos)
        timages.push(image)
        console.log("hashArray", hashArray);
    }

    const removePhoto = (e: any) => {
        console.log("hashArasyaya", hashArray);
        const name = e.filepath;
        var hash = CryptoJS.MD5(e.data).toString();
        console.log("test remove", hash, hashArray);
        hashArray.forEach(async (element: any) => {
          console.log("hashArray removal", hash, element);
          if (hash === element) {
            await removeHashes([element])
            hashArray = hashArray.filter((hash: any) => hash !== element)
          }
        });
        setImages(images.filter(image => image.filepath !== name));
      }

      const goBack = () => {
        if (history.length > 1) history.goBack();
        else history.replace('/Trip');
      };

      void trailerReport;

      return (
        <IonPage>
          <LoadDetailHeader title="Trailer Plate" onBack={goBack} onSheet={onSheet} />

          <IonToast
            isOpen={showToast}
            onDidDismiss={() => setShowToast(false)}
            message={toast}
            color="danger"
            duration={5000}
          />
           <IonModal isOpen={loading} id="transparent">
            <div className="modal-div">
              <div id="modal">
                <div className='loading-div'>
                  <p>Please wait... your photo is being submitted.</p>
                  <div className="snippet" data-title=".dot-flashing" style={{ margin: "4px 16px"}}>
                    <div className="stage">
                      <div className="dot-flashing"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </IonModal>
          <IonToast
            isOpen={successPhoto}
            onDidDismiss={() => {setLoading(false); setSuccess(false)}}
            message="Your photo was submitted."
            color="success"
            duration={3000}
          />
           <IonToast
            isOpen={showErrorModal}
            message="Error! Your photo could not be uploaded, check your connection and please try again."
            color="danger"
            duration={5000}
          />

          <IonContent
            fullscreen
            className="design-a-content design-a-content--light"
            scrollEvents={true}
            onIonScroll={onIonScroll}
          >
            <TrailerPhotoIdFirstIn>
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero photo-hero">
                  <div className="photo-hero__eyebrow">Trip documentation</div>
                  <div className="photo-hero__title home-display">Trailer Plate</div>
                  <div className="photo-hero__meta">
                    {images.length === 0 ? '1 photo required' : '1 photo ready to submit'}
                    {unitNumber ? ` · Unit ${unitNumber}` : ''}
                  </div>
                </div>

                <div className="home-sheet photo-sheet">
                  <div className="photo-card">
                    <div className="photo-card__title">Required view</div>
                    <p className="photo-card__body">
                      Submit a photo of the trailer with the plate clearly visible. Tap the example to
                      preview.
                    </p>
                    <div id="rearSideFrontSection" className="photo-examples">
                      <div className={`photo-example${openExample ? ' is-open' : ''}`}>
                        <button
                          type="button"
                          className="photo-example__header"
                          onClick={() => setOpenExample(!openExample)}
                          aria-expanded={openExample}
                          id="current-load-button"
                        >
                          <span className="photo-example__label">
                            <b>Front</b> view with trailer plate included
                          </span>
                          <span
                            className={`photo-example__chevron${openExample ? ' is-open' : ''}`}
                            aria-hidden="true"
                          >
                            <ChevronRight color="oklch(0.55 0.01 260)" />
                          </span>
                        </button>
                        <div className="photo-example__preview">
                          <img src={trailerId} alt="Front trailer plate example" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="photo-card">
                    <div className="photo-card__title">Your photo</div>
                    {images.length === 0 ? (
                      <p className="photo-empty">No photo yet. Capture the trailer plate.</p>
                    ) : (
                      <div className="photo-grid photo-grid--single">
                        {images.map((img, index) => (
                          <button
                            key={img.filepath || index}
                            type="button"
                            className="photo-thumb"
                            onClick={() => removePhoto(img)}
                            aria-label="Remove photo"
                          >
                            <img alt="Trailer plate photo" src={img.webviewPath} />
                            <span className="photo-thumb__remove">
                              <TrashIcon size={14} />
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div id="TarpPayBottom" className="photo-actions">
                    {images.length < 1 ? (
                      <button type="button" className="photo-capture" onClick={() => takePicture()}>
                        <CameraIcon size={20} />
                        <span>Take photo</span>
                      </button>
                    ) : null}
                    <button
                      type="button"
                      className="profile-submit"
                      disabled={images.length < 1}
                      onClick={() => submitTrailerIdPhotos()}
                    >
                      Submit trailer photo
                    </button>
                  </div>
                </div>
              </div>
            </TrailerPhotoIdFirstIn>
          </IonContent>
        </IonPage>
      );
    };

    export default TrailerIdPhotos;
